import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { PickupService } from '@checkout/feature';
import { MyShopService } from '@my-shop/feature';
import { CUSTOM_ICON_TYPE } from '@shared/models';
import { Pos } from '@shop/const';
import { ShopListService } from '@shop/feature';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { PickupState } from './pickup-address.model';

@Component({
  selector: 'sd-pickup-address',
  templateUrl: './pickup-address.component.html',
  styleUrls: ['./pickup-address.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorPickupAddressComponent implements OnInit {
  iconType = CUSTOM_ICON_TYPE;
  state = PickupState;
  state$: Observable<PickupState>;

  constructor(
    private pickupService: PickupService,
    private myShopService: MyShopService,
    private shopListService: ShopListService,
  ) {}

  ngOnInit(): void {
    this.state$ = combineLatest([
      this.pickupService.activeShop$,
      this.shopListService.noPosAvailable$,
      this.shopListService.shops$,
      this.myShopService.activeShop$,
    ]).pipe(
      map(([pickupShop, noPosAvailable, shops, myShop]: [Pos, boolean, Pos[], Pos]) => {
        if (noPosAvailable) {
          return this.state.NoPosAvailable;
        }

        if (pickupShop && shops && shops.some((shop) => shop.name === pickupShop.name)) {
          if (shops.length === 1) {
            return this.state.ShowPosOnlyOne;
          }

          return this.state.ShowPos;
        }

        if (myShop && shops && !shops.some((shop) => shop.name === myShop.name)) {
          return this.state.ShowPosNotAvailable;
        }

        return this.state.AddPos;
      }),
    );
  }
}
